var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress, Typography, Menu, MenuItem } from "@mui/material";
import { Publish, RotateLeft, PlayCircle, PauseCircle, StopCircle, PlaylistAddCheck, } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { Dialog } from "@sequentech/ui-essentials";
import { Button, FilterButton, SelectColumnsButton, useGetList, useRecordContext, } from "react-admin";
import { EPublishActionsType, EPublishType } from "./EPublishType";
import { PublishStatus, ElectionEventStatus, nextStatus } from "./EPublishStatus";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { EPublishActions } from "@/types/publishActions";
import { VotingStatusChannel } from "@/gql/graphql";
import { EBallotBoxSealPolicy, EGracePeriodPolicy, EInitializeReportPolicy, EVotingPeriodEnd, EVotingStatus, } from "@sequentech/ui-core";
import { usePublishPermissions } from "./usePublishPermissions";
import PublishExport from "./PublishExport";
import { useEventPresentation } from "@/hooks/useZonedFormat";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
import { intlLanguage } from "@/hooks/useZonedTime";
import { electionSealChannels, eventNamedChannels, eventStartChannels, keptClosedChannels, notEnabledStartChannels, neverOpened, onlineRan, sealProgress, stopSealOutcome, } from "@/services/sealOnStop";
import { useSealReadRole } from "@/hooks/useSealReadRole";
import { useQuery } from "@apollo/client";
import { GET_BALLOT_BOX_SEALS } from "@/queries/GetBallotBoxSeals";
var PublishActionsStyled = {
    Container: styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "], ["\n        display: flex;\n        margin-bottom: 8px;\n        justify-content: flex-end;\n        width: 100%;\n    "]))),
};
export var StyledStatusButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"], ["\n    &.MuiButtonBase-root {\n        line-height: 1 !important;\n    }\n\n    :disabled {\n        color: #ccc;\n        cursor: not-allowed;\n        background-color: #eee;\n    }\n"])));
export var StyledMenuItem = styled(MenuItem)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    &.MuiMenuItem-root {\n        display: flex;\n        gap: 8px;\n    }\n"], ["\n    &.MuiMenuItem-root {\n        display: flex;\n        gap: 8px;\n    }\n"])));
export var PublishActions = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var ballotPublicationId = _a.ballotPublicationId, type = _a.type, status = _a.status, publishType = _a.publishType, kioskModeEnabled = _a.kioskModeEnabled, onlineModeEnabled = _a.onlineModeEnabled, earlyVotingEnabled = _a.earlyVotingEnabled, telephoneVotingEnabled = _a.telephoneVotingEnabled, electionStatus = _a.electionStatus, electionPresentation = _a.electionPresentation, changingStatus = _a.changingStatus, onGenerate = _a.onGenerate, _h = _a.onPublish, onPublish = _h === void 0 ? function () { return null; } : _h, _j = _a.onChangeStatus, onChangeStatus = _j === void 0 ? function () { return null; } : _j, onInitialize = _a.onInitialize, _k = _a.initializing, initializing = _k === void 0 ? false : _k, _l = _a.perCountryInitialization, perCountryInitialization = _l === void 0 ? false : _l, initializationReportPolicy = _a.initializationReportPolicy, data = _a.data;
    var _m = useTranslation(), t = _m.t, i18n = _m.i18n;
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    var isGoldUser = authContext.isGoldUser, reauthWithGold = authContext.reauthWithGold;
    var canWrite = authContext.isAuthorized(true, tenantId, IPermissions.PUBLISH_WRITE);
    var record = useRecordContext();
    var isVotingPeriodEndDisallowed = (electionPresentation === null || electionPresentation === void 0 ? void 0 : electionPresentation.voting_period_end) == EVotingPeriodEnd.DISALLOWED;
    var canChangeStatus = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_STATE_WRITE);
    var requiredInitialization = (initializationReportPolicy !== null && initializationReportPolicy !== void 0 ? initializationReportPolicy : (_b = record === null || record === void 0 ? void 0 : record.presentation) === null || _b === void 0 ? void 0 : _b.initialization_report_policy) ===
        EInitializeReportPolicy.REQUIRED;
    // The trusted published requirement also controls ceremony availability.
    var canInitialize = publishType === EPublishType.Election &&
        !!onInitialize &&
        requiredInitialization &&
        authContext.isAuthorized(true, tenantId, IPermissions.ADMIN_CEREMONY);
    // const [addWidget, setWidgetTaskId, updateWidgetFail] = useWidgetStore()
    var eventPresentation = useEventPresentation();
    var aliasRenderer = useAliasRenderer();
    var _o = useState(false), showDialog = _o[0], setShowDialog = _o[1];
    var _p = useState(""), dialogText = _p[0], setDialogText = _p[1];
    var _q = useState(null), currentCallback = _q[0], setCurrentCallback = _q[1];
    var _r = useState(null), startAnchorEl = _r[0], setStartAnchorEl = _r[1];
    var startMenuOpen = Boolean(startAnchorEl);
    var _s = useState(null), pauseAnchorEl = _s[0], setPauseAnchorEl = _s[1];
    var pauseMenuOpen = Boolean(pauseAnchorEl);
    var _t = useState(null), stopAnchorEl = _t[0], setStopAnchorEl = _t[1];
    var stopMenuOpen = Boolean(stopAnchorEl);
    var _u = usePublishPermissions(), canPublishRegenerate = _u.canPublishRegenerate, canPublishStartVoting = _u.canPublishStartVoting, canPublishPauseVoting = _u.canPublishPauseVoting, canPublishStopVoting = _u.canPublishStopVoting, canPublishChanges = _u.canPublishChanges, showPublishColumns = _u.showPublishColumns, showPublishFilters = _u.showPublishFilters;
    var IconOrProgress = function (_a) {
        var st = _a.st, Icon = _a.Icon;
        return nextStatus(st) === status && status !== PublishStatus.Void ? (_jsx(CircularProgress, { size: 16 })) : (_jsx(Icon, { width: 24 }));
    };
    var StatusButton = function (_a) {
        var st = _a.st, label = _a.label, onClick = _a.onClick, Icon = _a.Icon, disabledStatus = _a.disabledStatus, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className;
        return (_jsx(Button, { onClick: onClick, className: className, label: String(t(label)), style: changingStatus || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status))
                ? {
                    overflow: "hidden",
                    color: "#ccc",
                    cursor: "not-allowed",
                    backgroundColor: "#eee",
                    padding: "6px 16px",
                }
                : {
                    overflow: "hidden",
                    padding: "6px 16px",
                }, disabled: disabled || (disabledStatus === null || disabledStatus === void 0 ? void 0 : disabledStatus.includes(status)) || st === status + 0.1, children: _jsx(IconOrProgress, { st: st, Icon: Icon }) }));
    };
    var openDialog = function (dialogText) {
        setDialogText(dialogText);
        setShowDialog(true);
    };
    // Handler for navigating after a re-authentication action.
    var reauthCallback = function (baseUrl, action, voting_channels) {
        // The event and election tabs select Publish by id; its position depends on permissions.
        baseUrl.searchParams.set("tabId", "publish");
        sessionStorage.setItem(action, "true");
        if (voting_channels &&
            (action === EPublishActions.PENDING_START_VOTING ||
                action === EPublishActions.PENDING_PAUSE_VOTING ||
                action === EPublishActions.PENDING_STOP_VOTING)) {
            try {
                sessionStorage.setItem("".concat(action, "_CHANNELS"), JSON.stringify(voting_channels));
            }
            catch (e) {
                console.warn("Could not persist selected channels for re-auth", e);
            }
        }
    };
    var sealsAtClose = (eventPresentation === null || eventPresentation === void 0 ? void 0 : eventPresentation.ballot_box_seal_policy) === EBallotBoxSealPolicy.SEAL_AT_CLOSE;
    // The event's elections, for what an event-wide Start or Stop does to each.
    var eventElections = useGetList("sequent_backend_election", {
        filter: { election_event_id: record === null || record === void 0 ? void 0 : record.id, tenant_id: tenantId },
        pagination: { page: 1, perPage: 9999 },
    }, { enabled: sealsAtClose && publishType === EPublishType.Event && !!(record === null || record === void 0 ? void 0 : record.id) }).data;
    // Whether this election has seals: then it never opens again (S3).
    var sealRole = useSealReadRole();
    var electionSeals = useQuery(GET_BALLOT_BOX_SEALS, {
        variables: {
            electionEventId: String((_c = record === null || record === void 0 ? void 0 : record.election_event_id) !== null && _c !== void 0 ? _c : ""),
            electionIds: [String((_d = record === null || record === void 0 ? void 0 : record.id) !== null && _d !== void 0 ? _d : "")],
        },
        skip: !sealsAtClose || publishType !== EPublishType.Election || !(record === null || record === void 0 ? void 0 : record.id) || !sealRole,
        context: sealRole ? { headers: { "x-hasura-role": sealRole } } : undefined,
    }).data;
    var electionHasSeals = !!((_e = electionSeals === null || electionSeals === void 0 ? void 0 : electionSeals.sequent_backend_ballot_box_seal) === null || _e === void 0 ? void 0 : _e.length);
    // The seals of the event's elections, for what an event-wide Start keeps closed.
    var eventSeals = useQuery(GET_BALLOT_BOX_SEALS, {
        variables: {
            electionEventId: String((_f = record === null || record === void 0 ? void 0 : record.id) !== null && _f !== void 0 ? _f : ""),
            electionIds: (eventElections !== null && eventElections !== void 0 ? eventElections : []).map(function (election) { return String(election.id); }),
        },
        skip: !sealsAtClose ||
            publishType !== EPublishType.Event ||
            !(eventElections === null || eventElections === void 0 ? void 0 : eventElections.length) ||
            !sealRole,
        context: sealRole ? { headers: { "x-hasura-role": sealRole } } : undefined,
    }).data;
    var sealedElectionIds = new Set(((_g = eventSeals === null || eventSeals === void 0 ? void 0 : eventSeals.sequent_backend_ballot_box_seal) !== null && _g !== void 0 ? _g : []).map(function (seal) { return String(seal.election_id); }));
    /** The channels as Stop Voting sees them, with when each first opened (election level). */
    var sealChannels = function () {
        var dates = function (key) {
            var _a;
            return (_a = electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus[key]) === null || _a === void 0 ? void 0 : _a.first_started_at;
        };
        return [
            {
                channel: VotingStatusChannel.Online,
                info: onlineModeEnabled,
                firstStartedAt: dates("voting_period_dates"),
            },
            {
                channel: VotingStatusChannel.Kiosk,
                info: kioskModeEnabled,
                firstStartedAt: dates("kiosk_voting_period_dates"),
            },
            {
                channel: VotingStatusChannel.EarlyVoting,
                info: earlyVotingEnabled,
                firstStartedAt: dates("early_voting_period_dates"),
            },
            {
                channel: VotingStatusChannel.Telephone,
                info: telephoneVotingEnabled,
                firstStartedAt: dates("telephone_voting_period_dates"),
            },
        ].map(function (_a) {
            var _b;
            var channel = _a.channel, info = _a.info, firstStartedAt = _a.firstStartedAt;
            return ({
                channel: channel,
                enabled: !!(info === null || info === void 0 ? void 0 : info.is_channel_enabled),
                status: (_b = info === null || info === void 0 ? void 0 : info.status) !== null && _b !== void 0 ? _b : EVotingStatus.NOT_STARTED,
                firstStartedAt: firstStartedAt,
            });
        });
    };
    var listFormat = function (items) {
        var _a;
        return new Intl.ListFormat(intlLanguage((_a = i18n === null || i18n === void 0 ? void 0 : i18n.language) !== null && _a !== void 0 ? _a : "en"), {
            style: "long",
            type: "conjunction",
        }).format(items);
    };
    var channelNames = function (channels) {
        return listFormat(channels.map(function (channel) { return t("publish.dialog.channel.".concat(channel)); }));
    };
    /**
     * The online grace period of an election in minutes, or 0. It applies only
     * when online voting ran (`deadline.rs`: ONLINE enabled and started).
     */
    var graceMinutes = function (presentation, ran) {
        var _a, _b;
        var value = (presentation !== null && presentation !== void 0 ? presentation : {});
        var secs = ran &&
            ((_a = value.grace_period_policy) !== null && _a !== void 0 ? _a : EGracePeriodPolicy.NO_GRACE_PERIOD) !==
                EGracePeriodPolicy.NO_GRACE_PERIOD
            ? ((_b = value.grace_period_secs) !== null && _b !== void 0 ? _b : 0)
            : 0;
        return Math.ceil(secs / 60);
    };
    /** The sentence said before a Stop's seal text: channels it closes before they ever opened. */
    var stopPrefix = function (stopping) {
        var closingUnopened = sealChannels()
            .filter(function (channel) {
            return channel.enabled &&
                channel.status === EVotingStatus.NOT_STARTED &&
                !channel.firstStartedAt &&
                (!stopping || stopping.includes(channel.channel));
        })
            .map(function (_a) {
            var channel = _a.channel;
            return channel;
        });
        return closingUnopened.length
            ? t("publish.dialog.stopNeverOpened", {
                count: closingUnopened.length,
                channels: channelNames(closingUnopened),
            })
            : "";
    };
    /**
     * Why a Stop doesn't seal the ballot boxes yet: the enabled channels still
     * open, and each channel the Post doesn't enable that isn't closed; or,
     * when no channel counts (none enabled and none ran), that.
     */
    var sealHoldingText = function (outcome) {
        return __spreadArray([
            !outcome.holding.length && !outcome.notEnabled.length
                ? t("publish.dialog.sealNoChannel")
                : "",
            outcome.holding.length
                ? t("publish.dialog.sealHolding", {
                    count: outcome.holding.length,
                    channels: channelNames(outcome.holding),
                })
                : ""
        ], outcome.notEnabled.map(function (channel) {
            return t("publish.dialog.sealNotEnabled", {
                channel: t("publish.dialog.channel.".concat(channel)),
            });
        }), true).filter(Boolean)
            .join(" ");
    };
    /**
     * What Stop Voting says when the event seals its ballot boxes at close
     * (D1): the seal text only when this Stop finishes voting; otherwise the
     * usual text with the channels that still hold the seal. Null when the
     * event doesn't seal them.
     */
    var stopSealText = function (stopping) {
        if (!sealsAtClose)
            return null;
        if (publishType === EPublishType.Event && eventElections) {
            // Unnamed, the server closes the event's enabled channels.
            return stopSealEventText(eventNamedChannels(sealChannels(), stopping));
        }
        var outcome = stopSealOutcome(sealChannels(), stopping);
        var prefix = stopPrefix(stopping);
        var text = outcome.seals
            ? stopSealBaseText()
            : t("publish.dialog.stopSealNotYet", { holding: sealHoldingText(outcome) });
        return [prefix, text].filter(Boolean).join(" ");
    };
    /** The seal text of a Stop that finishes voting at this election, with its grace period. */
    var stopSealBaseText = function () {
        if (publishType === EPublishType.Event)
            return t("publish.dialog.stopSealEvent");
        var name = aliasRenderer(record);
        var minutes = graceMinutes(electionPresentation, onlineRan(sealChannels()));
        return minutes > 0
            ? t("publish.dialog.stopSealGrace", { name: name, count: minutes })
            : t("publish.dialog.stopSeal", { name: name });
    };
    /**
     * An event-wide Stop, election by election with their own channels and
     * grace periods: which are sealed (now or after their grace period) and
     * which keep a channel that holds the seal.
     */
    var stopSealEventText = function (stopping) {
        var affected = (eventElections !== null && eventElections !== void 0 ? eventElections : [])
            .map(function (election) {
            var channels = electionSealChannels(election);
            return {
                election: election,
                before: sealProgress(channels),
                outcome: stopSealOutcome(channels, stopping),
                grace: graceMinutes(election.presentation, onlineRan(channels)),
                unopened: neverOpened(channels),
            };
        })
            // Elections whose voting had already finished don't change.
            .filter(function (_a) {
            var before = _a.before;
            return !before.finished;
        });
        // An event-wide Stop closes the channel on every election, so a Post
        // that never opened is closed for good and gets empty sealed boxes.
        var unopened = affected.filter(function (_a) {
            var outcome = _a.outcome, unopened = _a.unopened;
            return outcome.seals && unopened;
        });
        var sealing = affected.filter(function (_a) {
            var outcome = _a.outcome, unopened = _a.unopened;
            return outcome.seals && !unopened;
        });
        // Posts kept by an enabled channel; those kept only by channels they
        // don't enable are named with those channels; and those where no
        // channel counts (none enabled and none ran).
        var holding = affected.filter(function (_a) {
            var outcome = _a.outcome;
            return !outcome.seals && outcome.holding.length > 0;
        });
        var noChannel = affected.filter(function (_a) {
            var outcome = _a.outcome;
            return !outcome.seals && !outcome.holding.length && !outcome.notEnabled.length;
        });
        var notEnabled = affected.flatMap(function (_a) {
            var election = _a.election, outcome = _a.outcome;
            return outcome.seals
                ? []
                : outcome.notEnabled.map(function (channel) {
                    return t("publish.dialog.sealNotEnabledPost", {
                        post: aliasRenderer(election),
                        channel: t("publish.dialog.channel.".concat(channel)),
                    });
                });
        });
        var grace = Math.max.apply(Math, __spreadArray([0], sealing.map(function (item) { return item.grace; }), false));
        var names = function (items) {
            return listFormat(items.map(function (_a) {
                var election = _a.election;
                return aliasRenderer(election);
            }));
        };
        var unopenedPart = unopened.length
            ? "".concat(t("publish.dialog.stopNeverOpenedPosts", {
                count: unopened.length,
                names: names(unopened),
            }), " ")
            : "";
        if (!holding.length && !notEnabled.length && !noChannel.length) {
            return "".concat(unopenedPart).concat(grace > 0
                ? t("publish.dialog.stopSealEventGrace", { count: grace })
                : t("publish.dialog.stopSealEvent"));
        }
        var sealedPart = !sealing.length
            ? ""
            : grace > 0
                ? t("publish.dialog.sealedGracePart", { names: names(sealing), count: grace })
                : t("publish.dialog.sealedNowPart", { names: names(sealing) });
        var holdingPart = __spreadArray(__spreadArray([
            holding.length
                ? t("publish.dialog.holdingEventPart", {
                    count: holding.length,
                    names: names(holding),
                })
                : ""
        ], notEnabled, true), [
            noChannel.length
                ? t("publish.dialog.noChannelEventPart", {
                    count: noChannel.length,
                    names: names(noChannel),
                })
                : "",
        ], false).filter(Boolean)
            .join(" ");
        return "".concat(unopenedPart).concat(t("publish.dialog.stopSealEventSome", {
            sealed: sealedPart,
            holding: holdingPart,
        }))
            .replace(/\s+/g, " ")
            .trim();
    };
    /**
     * With the seal at close, an event Start names, Post by Post, what the
     * server leaves as it is (`manual_post_change`): per channel it applies,
     * a Post that doesn't enable that channel (it stays Not started there);
     * else a Post where that channel is CLOSED; and every enabled channel of
     * a Post with ballot box seals.
     */
    var startSealNote = function (starting) {
        if (!sealsAtClose || publishType !== EPublishType.Event)
            return null;
        if (!eventElections || (eventElections.length && !eventSeals)) {
            return t("publish.dialog.startSealNote");
        }
        var applied = eventStartChannels(sealChannels(), starting);
        var kept = [];
        var notEnabled = [];
        for (var _i = 0, eventElections_1 = eventElections; _i < eventElections_1.length; _i++) {
            var election = eventElections_1[_i];
            var post = aliasRenderer(election);
            var channels = electionSealChannels(election);
            var skipped = notEnabledStartChannels(channels, applied);
            if (skipped.length) {
                notEnabled.push(t("publish.dialog.startNotEnabledChannels", {
                    post: post,
                    count: skipped.length,
                    channels: channelNames(skipped),
                }));
            }
            if (sealedElectionIds.has(String(election.id))) {
                if (skipped.length < applied.length) {
                    kept.push(t("publish.dialog.startKeptSealed", { post: post }));
                }
                continue;
            }
            var closed_1 = keptClosedChannels(channels, applied);
            if (closed_1.length) {
                kept.push(t("publish.dialog.startKeptChannels", {
                    post: post,
                    count: closed_1.length,
                    channels: channelNames(closed_1),
                }));
            }
        }
        var sentences = [
            kept.length ? t("publish.dialog.startSealNoteList", { items: kept.join("; ") }) : null,
            notEnabled.length
                ? t("publish.dialog.startNotEnabledList", { items: notEnabled.join("; ") })
                : null,
        ].filter(Boolean);
        return sentences.length ? sentences.join(" ") : null;
    };
    /**
     * Specific Handler for Start/Pause/Stop Buttons:
     * Incorporates re-authentication logic for actions that require Gold-level permissions.
     */
    var handleChangeVotingPeriod = function (action, status, voting_channels) {
        var actionText = action === EPublishActions.PENDING_START_VOTING
            ? t("publish.action.startVotingPeriod")
            : action === EPublishActions.PENDING_STOP_VOTING
                ? t("publish.action.stopVotingPeriod")
                : t("publish.action.pauseVotingPeriod");
        // With the seal at close, the dialog says what this action does to the
        // ballot boxes, also before re-authenticating: whether a Stop seals
        // them, and that an event Start leaves closed elections closed.
        var sealText = action === EPublishActions.PENDING_STOP_VOTING
            ? stopSealText(voting_channels)
            : action === EPublishActions.PENDING_START_VOTING
                ? startSealNote(voting_channels)
                : null;
        var dialogMessage = isGoldUser()
            ? action === EPublishActions.PENDING_START_VOTING
                ? [t("publish.dialog.startInfo"), sealText].filter(Boolean).join(" ")
                : action === EPublishActions.PENDING_STOP_VOTING
                    ? (sealText !== null && sealText !== void 0 ? sealText : t("publish.dialog.stopInfo"))
                    : t("publish.dialog.pauseInfo")
            : [sealText, t("publish.dialog.confirmation", { action: actionText })]
                .filter(Boolean)
                .join(" ");
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, action, voting_channels);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onChangeStatus(status, voting_channels);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error("Re-authentication failed:", error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /** Initializing voting asks for confirmation, then creates the initialization report. */
    var handleInitialize = function () {
        openDialog(t("publish.dialog.initializationInfo"));
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, onInitialize === null || onInitialize === void 0 ? void 0 : onInitialize()];
        }); }); }; });
    };
    var isInitializeDisabled = function () {
        var _a;
        return changingStatus ||
            initializing ||
            (!!(record === null || record === void 0 ? void 0 : record.initialization_report_generated) && !perCountryInitialization) ||
            ((_a = electionStatus === null || electionStatus === void 0 ? void 0 : electionStatus.voting_status) !== null && _a !== void 0 ? _a : EVotingStatus.NOT_STARTED) !== EVotingStatus.NOT_STARTED;
    };
    /**
     * Specific Handler for "Publish Changes" Button: Incorporates
     * re-authentication logic for actions that require Gold-level permissions.
     */
    var handlePublish = function (is_generate) {
        var actionText = t("publish.action.publish");
        var dialogMessage = isGoldUser()
            ? is_generate
                ? t("publish.dialog.info")
                : t("publish.dialog.publishInfo", { action: actionText })
            : t("publish.dialog.confirmation", { action: actionText });
        openDialog(dialogMessage);
        setCurrentCallback(function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
            var baseUrl, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!!isGoldUser()) return [3 /*break*/, 2];
                        baseUrl = new URL(window.location.href);
                        reauthCallback(baseUrl, EPublishActions.PENDING_PUBLISH_ACTION);
                        return [4 /*yield*/, reauthWithGold(baseUrl.toString())];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        onGenerate();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.error("Re-authentication failed:", error_2);
                        setDialogText(t("publish.dialog.errorReauth"));
                        setShowDialog(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); }; });
    };
    /**
     * Checks for any pending actions after the component mounts. If a pending
     * action is found, it executes the action and removes the flag. Except to
     * publish action, which is handled in the useEffect of the parent
     * component.
     */
    useEffect(function () {
        var executePendingActions = function () { return __awaiter(void 0, void 0, void 0, function () {
            var isGold, pendingStart, selectedChannels, channelsStr, pendingPause, selectedPauseChannels, channelsStr, pendingStop, selectedStopChannels, channelsStr, pendingStopKiosk;
            return __generator(this, function (_a) {
                if (!record) {
                    return [2 /*return*/];
                }
                isGold = isGoldUser();
                pendingStart = sessionStorage.getItem(EPublishActions.PENDING_START_VOTING);
                if (pendingStart) {
                    selectedChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_START_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Open, selectedChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_START_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_START_VOTING, "_CHANNELS"));
                }
                pendingPause = sessionStorage.getItem(EPublishActions.PENDING_PAUSE_VOTING);
                if (pendingPause) {
                    selectedPauseChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_PAUSE_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedPauseChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected pause channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Paused, selectedPauseChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_PAUSE_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_PAUSE_VOTING, "_CHANNELS"));
                }
                pendingStop = sessionStorage.getItem(EPublishActions.PENDING_STOP_VOTING);
                if (pendingStop) {
                    selectedStopChannels = undefined;
                    try {
                        channelsStr = sessionStorage.getItem("".concat(EPublishActions.PENDING_STOP_VOTING, "_CHANNELS"));
                        if (channelsStr) {
                            selectedStopChannels = JSON.parse(channelsStr);
                        }
                    }
                    catch (e) {
                        console.warn("Could not restore selected stop channels after re-auth", e);
                    }
                    isGold && onChangeStatus(ElectionEventStatus.Closed, selectedStopChannels);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_VOTING);
                    sessionStorage.removeItem("".concat(EPublishActions.PENDING_STOP_VOTING, "_CHANNELS"));
                }
                pendingStopKiosk = sessionStorage.getItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                if (pendingStopKiosk) {
                    isGold && onChangeStatus(ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                    sessionStorage.removeItem(EPublishActions.PENDING_STOP_KIOSK_ACTION);
                }
                return [2 /*return*/];
            });
        }); };
        executePendingActions();
    }, [isGoldUser, onChangeStatus, onGenerate, record]);
    // Per-channel menu item disable logic
    var isStartChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        return (!channelEnabled ||
            st === EVotingStatus.OPEN ||
            st === EVotingStatus.CLOSED ||
            // With Seal at close, an election with seals never opens again.
            electionHasSeals);
    };
    var isPauseChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        return (!channelEnabled ||
            st === EVotingStatus.NOT_STARTED ||
            st === EVotingStatus.PAUSED ||
            st === EVotingStatus.CLOSED);
    };
    var isStopChannelDisabled = function (info) {
        var _a;
        var channelEnabled = (_a = info === null || info === void 0 ? void 0 : info.is_channel_enabled) !== null && _a !== void 0 ? _a : false;
        var st = info === null || info === void 0 ? void 0 : info.status;
        // With Seal at close, an election's Stop closes any channel that
        // isn't CLOSED, enabled or not and started or not, so none holds the
        // seal: closing lets no ballot in (D1, R10 B1).
        if (sealsAtClose && publishType === EPublishType.Election) {
            return st === EVotingStatus.CLOSED;
        }
        return !channelEnabled || st === EVotingStatus.CLOSED || st === EVotingStatus.NOT_STARTED;
    };
    var initializationReportNotGenerated = function () {
        return requiredInitialization && !(record === null || record === void 0 ? void 0 : record.initialization_report_generated);
    };
    // Encapsulated original disabled logic for each main action button
    var isStartButtonDisabled = function () {
        var allChannelsDisabled = isStartChannelDisabled(kioskModeEnabled) &&
            isStartChannelDisabled(onlineModeEnabled) &&
            isStartChannelDisabled(earlyVotingEnabled) &&
            isStartChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [PublishStatus.GeneratedLoading].includes(status) ||
            allChannelsDisabled);
    };
    var isPauseButtonDisabled = function () {
        var allChannelsDisabled = isPauseChannelDisabled(kioskModeEnabled) &&
            isPauseChannelDisabled(onlineModeEnabled) &&
            isPauseChannelDisabled(earlyVotingEnabled) &&
            isPauseChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [
                // PublishStatus.Void,
                PublishStatus.Generated,
                PublishStatus.GeneratedLoading,
            ].includes(status) ||
            allChannelsDisabled);
    };
    var isStopButtonDisabled = function () {
        var allChannelsDisabled = isStopChannelDisabled(kioskModeEnabled) &&
            isStopChannelDisabled(onlineModeEnabled) &&
            isStopChannelDisabled(earlyVotingEnabled) &&
            isStopChannelDisabled(telephoneVotingEnabled);
        return (changingStatus ||
            [
                // PublishStatus.Void,
                PublishStatus.Generated,
                PublishStatus.GeneratedLoading,
            ].includes(status) ||
            allChannelsDisabled);
    };
    return (_jsxs(_Fragment, { children: [electionHasSeals ? (_jsx(Typography, { variant: "body2", color: "text.secondary", sx: { textAlign: "right", mb: 1 }, className: "publish-seal-start-reason", children: t("publish.sealRefusals.startDisabled") })) : null, _jsx(PublishActionsStyled.Container, { children: _jsx("div", { className: "list-actions", style: {
                        display: "flex",
                        gap: 0,
                        alignItems: "center",
                        justifyContent: "flex-end",
                    }, children: type === EPublishActionsType.List ? (_jsxs(_Fragment, { children: [showPublishColumns ? _jsx(SelectColumnsButton, {}) : null, showPublishFilters ? _jsx(FilterButton, {}) : null, canInitialize && (_jsx(StyledStatusButton, { onClick: handleInitialize, className: "initializeVoting", label: String(t("publish.action.generateInitializationReport")), disabled: isInitializeDisabled(), children: initializing ? (_jsx(CircularProgress, { size: 16 })) : (_jsx(PlaylistAddCheck, { width: 24 })) })), canChangeStatus && canPublishStartVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setStartAnchorEl(e.currentTarget);
                                        }, className: "startVotingMenu", label: String(t("publish.action.startVotingPeriod")), disabled: isStartButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Started, Icon: PlayCircle }) }), _jsxs(Menu, { anchorEl: startAnchorEl, open: startMenuOpen, onClose: function () { return setStartAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isStartChannelDisabled(onlineModeEnabled) ||
                                                    initializationReportNotGenerated(), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.startOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.startKioskVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.startEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isStartChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setStartAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_START_VOTING, ElectionEventStatus.Open, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.startTelephoneVoting") })] })] })), canChangeStatus && canPublishPauseVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setPauseAnchorEl(e.currentTarget);
                                        }, className: "pauseVotingMenu", label: String(t("publish.action.pauseVotingPeriod")), disabled: isPauseButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Paused, Icon: PauseCircle }) }), _jsxs(Menu, { anchorEl: pauseAnchorEl, open: pauseMenuOpen, onClose: function () { return setPauseAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(onlineModeEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.pauseOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.pauseKioskVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.pauseEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isPauseChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setPauseAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_PAUSE_VOTING, ElectionEventStatus.Paused, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.pauseTelephoneVoting") })] })] })), canChangeStatus && canPublishStopVoting && (_jsxs(_Fragment, { children: [_jsx(StyledStatusButton, { onClick: function (e) {
                                            return setStopAnchorEl(e.currentTarget);
                                        }, className: "stopVotingMenu", label: String(t("publish.action.stopVotingPeriod")), disabled: isStopButtonDisabled(), children: _jsx(IconOrProgress, { st: PublishStatus.Stopped, Icon: StopCircle }) }), _jsxs(Menu, { anchorEl: stopAnchorEl, open: stopMenuOpen, onClose: function () { return setStopAnchorEl(null); }, anchorOrigin: { vertical: "bottom", horizontal: "left" }, transformOrigin: { vertical: "top", horizontal: "left" }, children: [_jsx(StyledMenuItem, { disabled: isStopChannelDisabled(onlineModeEnabled) ||
                                                    isVotingPeriodEndDisallowed, onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Online]);
                                                }, children: t("publish.action.stopOnlineVoting") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(kioskModeEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Kiosk]);
                                                }, children: t("publish.action.stopKioskVotingPeriod") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(earlyVotingEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.EarlyVoting]);
                                                }, children: t("publish.action.stopEarlyVoting") }), _jsx(StyledMenuItem, { disabled: isStopChannelDisabled(telephoneVotingEnabled), onClick: function () {
                                                    setStopAnchorEl(null);
                                                    handleChangeVotingPeriod(EPublishActions.PENDING_STOP_VOTING, ElectionEventStatus.Closed, [VotingStatusChannel.Telephone]);
                                                }, children: t("publish.action.stopTelephoneVoting") })] })] })), canWrite && canPublishChanges && (_jsx(StatusButton, { Icon: Publish, onClick: function () { return handlePublish(false); }, st: PublishStatus.Generated, label: String(t("publish.action.publish")), disabledStatus: [], disabled: changingStatus }))] })) : (_jsxs(_Fragment, { children: [canWrite && canPublishRegenerate && (_jsx("div", { className: "list-actions", style: { paddingBottom: "4px" }, children: _jsx(StatusButton, { Icon: RotateLeft, disabledStatus: [], st: PublishStatus.Generated, label: String(t("publish.action.generate")), onClick: function () { return handlePublish(true); } }) })), canWrite && (_jsx(PublishExport, { ballotPublicationId: ballotPublicationId }))] })) }) }), _jsx(Dialog, { handleClose: function (flag) {
                    if (flag && currentCallback) {
                        currentCallback(); // Execute the saved callback
                    }
                    setShowDialog(false); // Close the dialog
                    setCurrentCallback(null); // Reset the callback
                }, open: showDialog, title: String(t("publish.dialog.title")), ok: String(t("publish.dialog.ok")), cancel: String(t("publish.dialog.ko")), variant: "info", children: _jsx(Typography, { variant: "body1", children: dialogText }) })] }));
};
var templateObject_1, templateObject_2, templateObject_3;
